"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.REACT_APP_API_URL = void 0;
exports.REACT_APP_API_URL = (_a = process.env.REACT_APP_API_URL, _a === void 0 ? '/api' : _a);
